import type { Action, ActionError } from '@/workflow-builder/_contract/command';

export function createActionError(command: Action['command'], message: string): ActionError {
    return {
        command,
        message,
    };
}
